import { css as _css } from "@emotion/core";
var _excluded = ["appearance", "baseId", "small", "totalPages"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import NavigationButton from './navigation-button';
import PageButton from './page-button';
import { pages, pagesRolling } from './util/pages';
import * as styles from './style/paginator.style';
import { boxShadow, desktopOnly, mobileOnly, variables } from './style/global';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var Appearances;
(function (Appearances) {
  Appearances["ROLLING"] = "rolling";
  Appearances["REGULAR"] = "regular";
})(Appearances || (Appearances = {}));
var Paginator = props => {
  var _props$appearance = props.appearance,
    appearance = _props$appearance === void 0 ? Appearances.REGULAR : _props$appearance,
    baseId = props.baseId,
    _props$small = props.small,
    small = _props$small === void 0 ? false : _props$small,
    totalPages = props.totalPages,
    pageButtonProps = _objectWithoutProperties(props, _excluded);
  var paginator = appearance === Appearances.ROLLING ? pagesRolling : pages;
  var isSmall = small || totalPages < 5;
  return totalPages >= 1 ? ___EmotionJSX("div", {
    css: /*#__PURE__*/_css([styles.container(isSmall), variables]),
    id: baseId ? "".concat(baseId, "-paginator") : undefined
  }, ___EmotionJSX(NavigationButton, _extends({
    type: "prev"
  }, props)), ___EmotionJSX("div", {
    css: /*#__PURE__*/_css([styles.pagesContainer, props.hasShadow && boxShadow])
  }, paginator(totalPages, props.currentPage, small).map(item => 'spacer' in item ? ___EmotionJSX("span", {
    "data-testid": "paginator-spacer",
    css: /*#__PURE__*/_css([styles.spacer, item.hideIfMobile && desktopOnly, item.hideIfNotMobile && mobileOnly]),
    key: item.key
  }, item.pageNumber) : ___EmotionJSX(PageButton, _extends({
    hideIfMobile: item.hideIfMobile,
    pageNumber: item.pageNumber
  }, pageButtonProps, {
    key: item.pageNumber,
    urlTemplate: props.urlTemplate
  })))), ___EmotionJSX(NavigationButton, _extends({
    type: "next"
  }, props))) : null;
};
export default Paginator;